import React from "react";
import _ from "lodash";

const JudgmentLimit = ({ value, boundaryType, unit, type }) => {
  let result = "-";
  let title = "";
  if (!_.isEmpty(value)) {
    let newUnit = "";
    if (!_.isEmpty(unit)) {
      newUnit = unit.length > 9 ? unit.slice(0, 9) + "..." : unit;
    }
    let boundaryTypeJP = type === "upper" ? "未満" : "超過";
    if (boundaryType === 1) {
      boundaryTypeJP = type === "upper" ? "以下" : "以上";
    }
    result = value + newUnit + boundaryTypeJP;
    title = value + unit + boundaryTypeJP;
  }
  return (
    <span className="break-all" title={title}>
      {result}
    </span>
  );
};

export default JudgmentLimit;
